<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="55rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.clientInfo')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <v-divider class="mb-4"></v-divider>
        <!--content-->
        <v-card-text>
          <div class="form-group row-ty">
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.clientName')}}<span class="imp">*</span>
              </div>
              <div class="row">
                <c-Input v-bind="client" v-model="clientName" :name="'clientName'" @keydown.enter.prevent/>
              </div>
            </div>
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.maxGroupCnt')}}
              </div>
              <div class="row">
                <c-Input v-bind="groupNum" v-model="maxGroup" :name="'maxGroup'" @keydown.enter.prevent/>
              </div>
            </div>
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.maxUserCnt')}}
                <c-tooltip v-bind="groupNumTooltip"/>
              </div>
              <div class="row">
                <c-Input v-bind="userNum" v-model="maxUser" :name="'maxUser'" @keydown.enter.prevent/>
              </div>
            </div>
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.groupAdminId')}}<span class="imp">*</span>
                <c-tooltip v-bind="managerTooltip"/>
              </div>
              <div class="row">
                <c-InputIdAdd :type="'client'"/>
              </div>

            </div>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end">
          <c-btn02 v-bind="btnDel" @click.prevent="dialogModel=true"/>
          <c-btn01 v-bind="btnSave" @click="validateAll"/>
        </v-card-actions>
      </v-card>
      <!--삭제-->
      <c-dialog v-model="dialogModel"
                v-bind="dialogBind"
                @close="dialogModel=false"
                @confirm="confirmDelete"
      />
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue'
import OrganizationService from "@/services/organization.service";
import utils from "@/common/Utils";
import { useCommonStore } from "@/store/common";
import {storeToRefs} from "pinia";
import { useForm } from "vee-validate";
import * as yup from "yup";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//popup close logic
const emit = defineEmits(['close'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
  clientName: yup.string().required(() => t('message.requiredField')),
  maxGroup: yup.number().typeError(() => t('message.onlyNumbersAllowed')).required(() => t('message.requiredField')),
  maxUser: yup.number().typeError(() => t('message.onlyNumbersAllowed')).required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const form = ref(null)
const clientName = ref('')
const dialogModel = ref(false)
const maxGroup = ref('')

//ui
const dialogBind = computed(() =>({
  dialogTit: t('message.delete'),
  dialogText: t('message.confirmDeleteSelectedClient'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}))
const client = computed(() =>({
  type: 'text',
  placeholder: t('message.enterClientName'),
}))
const groupNum = computed(() =>({
  type: 'text',
  placeholder: t('message.enterMaxGroupCount')
}))
let maxUser = ref('')
const userNum = computed(() =>({
  type: 'text',
  placeholder: t('message.enterMaxUserCount')
}))
const groupNumTooltip = computed(() =>({
  TooltipText: t('message.maxUserLicenseNotice')
}))
const managerTooltip = computed(() =>({
  TooltipText: t('message.groupAdminPermissionInfo')
}))
const btnDel = computed(() =>({
  btnText: t('message.delete'),
  btnType: 'reset'
}))
const btnSave = computed(() =>({
  btnText: t('message.save'),
  btnType: 'button'
}))

//hook
onBeforeUpdate (()=>{
  clientName.value = ''
  maxGroup.value = ''
  maxUser.value = ''
  storeRef.adminList.value = []
})

onUpdated (() => {
  if(!dialog.value)
    return;

  let params = {
    idx: storeRef.popupIdx.value,
  }

  if(params.idx){
    OrganizationService.getClient(params).then(
      (response) => {
        clientName.value = response.result.clientName
        maxGroup.value = response.result.maxGroup
        maxUser.value = response.result.maxUser
        storeRef.adminList.value = response.result.adminList
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

//function
const validateAll = async () => {
  const result = await validate(); // 전체 필드 검증 실행
  if(result.valid)
    handleForm()
}

function handleForm(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    if(utils.isEmpty(storeRef.adminList.value)){
      snackText.value = t('message.enterGroupUserId')
      snackbar.value = true
      return
    }

    let params = {
      idx: storeRef.popupIdx.value,
      clientName: clientName.value,
      maxGroup: maxGroup.value,
      maxUser: maxUser.value,
      adminList: storeRef.adminList.value
    }

    OrganizationService.insertUpdateClient(params).then(
      (response) => {
        storeRef.popupIdx.value = null
        emit('close', 'refresh')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

function confirmDelete(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    let clientIdx = storeRef.popupIdx.value
    if(utils.isEmpty(clientIdx))
      utils.movePage('/login')
    let params = {
      idx: clientIdx,
      delYn: 'Y',
    }

    OrganizationService.insertUpdateClient(params).then(
      (response) => {
        emit('close', 'refresh')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
</script>


<style lang="scss">
</style>
